var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_708_9411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 6.14301V18.967L9.065 16.797L15.065 19.797L20 17.68V4.85701L21.303 4.29901C21.3791 4.2664 21.4621 4.25318 21.5445 4.26056C21.627 4.26793 21.7063 4.29566 21.7754 4.34126C21.8445 4.38686 21.9012 4.4489 21.9404 4.52181C21.9796 4.59473 22.0001 4.67623 22 4.75901V19L15 22L9 19L2.697 21.701C2.62091 21.7336 2.53792 21.7468 2.45547 21.7395C2.37301 21.7321 2.29368 21.7044 2.22459 21.6588C2.1555 21.6132 2.09881 21.5511 2.05961 21.4782C2.02041 21.4053 1.99993 21.3238 2 21.241V7.00001L4 6.14301ZM16.243 11.243L12 15.485L7.757 11.243C6.91799 10.4039 6.34664 9.33476 6.11521 8.1709C5.88379 7.00704 6.00266 5.80069 6.45682 4.7044C6.91098 3.6081 7.68001 2.67109 8.66668 2.01184C9.65336 1.3526 10.8134 1.00073 12 1.00073C13.1866 1.00073 14.3466 1.3526 15.3333 2.01184C16.32 2.67109 17.089 3.6081 17.5432 4.7044C17.9973 5.80069 18.1162 7.00704 17.8848 8.1709C17.6534 9.33476 17.082 10.4039 16.243 11.243ZM12 12.657L14.828 9.82801C15.3875 9.26865 15.7686 8.55592 15.9231 7.77997C16.0775 7.00401 15.9983 6.19968 15.6956 5.4687C15.3929 4.73773 14.8802 4.11294 14.2224 3.67337C13.5646 3.23379 12.7912 2.99916 12 2.99916C11.2088 2.99916 10.4354 3.23379 9.77759 3.67337C9.11977 4.11294 8.60708 4.73773 8.30437 5.4687C8.00165 6.19968 7.92251 7.00401 8.07695 7.77997C8.23139 8.55592 8.61247 9.26865 9.172 9.82801L12 12.657Z",
    fill: "#595D67"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_708_9411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.ec940d2901874d0237e7dd5d7e6506e7.svg";
export { ForwardRef as ReactComponent };